import React from 'react'
import { ModelWithForm, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'
import AdminPage from 'pages/app/AdminPage'
import * as UI from 'ui'
import * as Fields from 'support/fields'
import Fieldset from 'layouts/form/Fieldset'
import PinField from 'support/fields/custom/PinField'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Pipeline } from '@morningtrain/react-pipelines'
import { RefreshAuthOnPipe } from '@morningtrain/react-auth'

export default function Index () {
  return (
    <AdminPage withGlobalDepartmentFilter={false}>
      <Translator namespace='profile'>

        <ModelWithForm resourceName='users.profile' operationName='current_user'>
          <Pipeline>
            <TriggerPipelineOnFormSubmit />
            <RefreshAuthOnPipe />
          </Pipeline>

          <UI.PageHeader title={<TranslatedTitle />}>
            <div className='form-actions'>
              <input className='w-full' type='submit' value='Gem' />
            </div>
          </UI.PageHeader>

          <UI.CardGroup>
            <UI.Card>
              <Fieldset cols={3}>
                <Fields.Input
                  name='first_name'
                  label={<Translation name='fields.first_name.label' />}
                />
                <Fields.Input
                  name='last_name'
                  label={<Translation name='fields.last_name.label' />}
                />
                <Fields.Input
                  name='email'
                />
              </Fieldset>
            </UI.Card>

            <UI.CardWithHeader header={<Translation name='fields.credentials.label' />}>
              <Fieldset cols={3}>
                <PinField />
                <Fields.Password name='password' label={<Translation name='fields.new_password.label' />} />
                <Fields.Password name='password_confirmation' label={<Translation name='fields.confirm_password.label' />} />
              </Fieldset>
            </UI.CardWithHeader>

            <UI.CardWithHeader header={<Translation name='fields.personal_information.label' />}>
              <Fieldset>
                <Fieldset cols={3}>
                  <Fields.Input
                    name='cpr'
                    label={<Translation name='fields.cpr.label' />}
                  />
                  <Fields.Select
                    label={<Translation name='fields.gender.label' />}
                    enum='gender' name='gender'
                  />
                  <Fields.Checkbox
                    name='is_student'
                    label={<Translation name='fields.is_student.label' />}
                  />
                </Fieldset>
                <Fieldset cols={3}>
                  <Fields.Input
                    name='address'
                    label={<Translation name='fields.address.label' />}
                  />
                  <Fields.Input
                    name='zipcode'
                    label={<Translation name='fields.zipcode.label' />}
                  />
                  <Fields.Input
                    name='phone'
                    label={<Translation name='fields.phone.label' />}
                  />
                </Fieldset>
              </Fieldset>
            </UI.CardWithHeader>

            <UI.CardWithHeader header={<Translation name='fields.bank_information.label' />}>
              <Fieldset cols={2}>
                <Fields.Input
                  name='bank_reg'
                  label={<Translation name='fields.bank_reg.label' />}
                />
                <Fields.Input
                  name='bank_account'
                  label={<Translation name='fields.bank_account.label' />}
                />
              </Fieldset>
            </UI.CardWithHeader>
          </UI.CardGroup>
        </ModelWithForm>
      </Translator>
    </AdminPage>
  )
}
